import HttpClient from "../helpers/HttpClient";
import { useIonLoading } from "@ionic/react";

export const useTaxNumberQuery = () => {
  const [presentLoading, dismissLoading] = useIonLoading();

  const fetchTaxNumberDetails = async (params: any): Promise<null | { name: string; addresses: any[] }> => {
    if (params.CPH_CustomerVatData === "thirdStateTaxId") {
      return null;
    }

    presentLoading("Kérjük várjon...");
    const result = await HttpClient({
      url: `/v2/tax-number`,
      method: "get",
      params,
    });
    dismissLoading();

    const data = result.data.data;

    if (params.CPH_CustomerVatData === "communityVatNumber" && data.communityVatNumber) {
      // EU
      return {
        name: data.communityVatNumber.name,
        addresses: [],
      };
    }

    if (params.CPH_CustomerVatData === "customerTaxNumber" && data.customerTaxNumber) {
      // NAV
      return {
        name: data.customerTaxNumber.taxpayerName,
        addresses: data.customerTaxNumber.taxpayerAddressList.taxpayerAddressItem,
      };
    }

    return null;
  };

  return {
    fetchTaxNumberDetails,
  };
};
